// components/PublicRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const PublicRoute = ({ children }) => {
  const { currentUser, loading, isAdmin } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // If user is authenticated and email verified, redirect to admin dashboard
  if (currentUser && currentUser.emailVerified) {
    // Check if user is admin and approved
    if (isAdmin) {
      return <Navigate to="/admin/dashboard" replace />;
    }
    // For regular authenticated users, you might want to redirect to a user dashboard
    // For now, redirect to home or you can create a user dashboard
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PublicRoute;